import { render, staticRenderFns } from "./ScreenGiftCard.vue?vue&type=template&id=e71b3f00"
import script from "./ScreenGiftCard.vue?vue&type=script&lang=js"
export * from "./ScreenGiftCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports